###
Base Class for any dialog based content.
The layoutURL that loadLayout calls should include the (excluding the
outer wrapper div that sets the class as modal, etc)
markup for the dialog itself, in a generic form, usually
as a jsrender template that dynamic data will be loaded into
###


class exports.DialogHandler extends Handler

    constructor: (args...) ->
        super(args...)

        @layoutSelector = null
        @refreshNavHandler = true
        @defaultSave = true
        @saveData = {}
        @saveUrl = ''
        @emptySidebarWriter = false
        @async = true

        # Auto bind clicking .save-btn or anything else that submits form
        @submitBindings = true
        #@submitAction = () ->

        @draggable = true
        @resizable = true
        @startPosition = 'center'
        @useMessageWriter = true
        @slideUpForm = true
        @modalOptions = {}
        @savingBtnMsg = 'Saving...'
        @savedBtnMsg = 'Saved'

        @classes = ''
        @allow_overflow = false
        @id = ( new Date() ).getTime()

        # todo: why aren't these defined as class methods like normal?
        @saveAction = () -> # stub
            undefined
        @errorAction = () -> # stub
            undefined
        @successAction = () -> # stub
            undefined
        @afterHidden = () =>
            if not @refreshing
                @destroy()
            @refreshing = false

        @destroyOnSave = true
        @delayAfterSuccess = false

        @refreshing = false


    init: () -> # stub
        undefined

    submitAction: () -> # stub
        undefined

    bindForSubmit: () ->
        @clearSubmitBind()
        @dialog.bind 'keypress', (e) =>
            if e.keyCode is 13
                e.preventDefault()
                @submitAction()

        @dialog.on 'keypress', 'textarea', (e) =>
            e.stopPropagation()


        @dialog.delegate 'form', 'submit', (e) =>
            e.preventDefault()
            @submitAction()

        @dialog.delegate '.save-btn', 'click', () =>
            f = @dialog.find('form')
            if f.length > 0
                f.submit()
            else
                @submitAction()


    clearSubmitBind: () ->
        @dialog.unbind 'keypress'
        @dialog.undelegate 'form', 'submit'
        @dialog.undelegate '.save-btn', 'click'


    createDialog: (loadOpts = {}) ->
        ###
        Adds the actual div that will be modalized, then content is loaded later
        ###
        id = @id
        classlist = "modal hide #{@classes}"
        if not @allow_overflow
            classlist = "no-overflow #{classlist}"


        $('#bs2-container').append("<div class='#{classlist}' id='#{id}'></div>")

        @layoutSelector = "##{id}"
        @dialog = $(@layoutSelector)

        defaults =
            callback: (selector, data) =>
                #@dialog.html(data)

                if @resizable
                    @dialog.resizable
                        alsoResize: @dialog.find('.modal-body')

                if @draggable
                    @dialog.draggable
                        handle: '.modal-header'

                if @useMessageWriter
                    writer = @dialog.find('.message_writer')
                    if writer.length isnt 0
                        writer.message_writer
                            autoHide: false

                if @submitBindings
                    @bindForSubmit()

                @afterLoadLayout(selector, data)

        opts = $.extend(defaults, loadOpts)

        @makeModal @modalOptions

        @loadLayout opts


    makeModal: (modal_options = {}) ->
        defaultModal =
            show: false
            backdrop: false

        modeOpts = $.extend(defaultModal, modal_options)

        @dialog.modal modeOpts

        @dialog.on 'hidden', (e) =>
            if $(e.target).is @dialog
                @dialog.off()
                @afterHidden()


    displayLoadingMessage: (message) ->
        @dialog.addClass 'dialog-loading'
        message ?= 'Loading data...'
        @dialog.html "<div class='shield'>#{message}</div>"


    openDialog: () ->
        if @dialog?
            @dialog.modal('show')

        # Auto focus first input
        @dialog.find('input,select')[0]?.focus()

        if @startPosition?
            @setPosition(@startPosition)


    closeDialog: () ->
        if @dialog?
            @dialog.modal('hide')


    afterLoadLayout: () -> # stub
        undefined

    destroy: () ->
        if @dialog?
            @closeDialog()
            @dialog.remove()
        #$(window).trigger("dialog_destroyed",[this])
        super()


    refresh: () ->
        @refreshing = true
        @closeDialog()
        if @dialog?
            @dialog.remove()
        super()


    getPostData: () ->
        saveData = @dialog.find('form').serialize()
        if @saveData
            saveData += '&' if saveData
            saveData += $.param(@saveData) if @saveData
        return saveData


    save: (msg) ->
        self = this

        # This allows form elements to get stored in KO viewmodels before trying to save.
        # This bug is apparent when you hit "enter" after changing a non-validating form element
        # to a validating value but without losing focus on the input first.
        document.activeElement.blur()

        if @useMessageWriter
            writer = self.dialog.find('.message_writer')

        self.beforeSave()

        if self.defaultSave

            saveData = self.getPostData()

            ### Validate saveData here... ###
            if @useMessageWriter and writer.length isnt 0 and $.contains(document, writer[0])
                writer.message_writer 'info', msg

            # disable the button until the save request returns
            saveBtn = self.dialog.find('.save-btn')
            if saveBtn.length
                if not saveBtn.attr('data-saving-text')
                    saveBtn.attr('data-saving-text', self.savingBtnMsg)
                if not saveBtn.attr('data-saved-text')
                    saveBtn.attr('data-saved-text', self.savedBtnMsg)

                saveBtn.button('saving').prop('disabled', true)

                # Bootstrap has a dumb. I filed a bug report.
                # https://github.com/twbs/bootstrap/issues/10890
                # If they fix it, then we can delete this piece of code.
                setTimeout () ->
                    saveBtn.prop('disabled', true)
                , 0

            processData = true
            contentType = 'application/x-www-form-urlencoded; charset=UTF-8'

            if saveData instanceof FormData
                processData = false
                contentType = false

            $.ajax
                type: 'POST'
                url: self.saveUrl
                data: saveData
                processData: processData
                contentType: contentType
                async: self.async

                success: (response) ->
                    if self.destroyOnSave and response.status?.type is 'success'
                        # if destroyOnSave is set, update the button, but leave
                        # it disabled in order to prevent the user from
                        # accidentally saving it again, as this can be
                        # problematic.
                        saveBtn.button('saved').prop('disabled', true)

                        # Bootstrap has a dumb. I filed a bug report.
                        # https://github.com/twbs/bootstrap/issues/10890
                        # If they fix it, then we can delete this piece of code.
                        setTimeout () ->
                            saveBtn.prop('disabled', true)
                        , 0
                    else
                        # if not, or if there's an error, reset the button,
                        # since it may still be used
                        saveBtn.button('reset')

                    ###
                    See Dialog_Handler.afterSave(). This handles displaying errors
                    and closing the dialog/refreshing the current Primary Nav Handler
                    ###
                    self.afterSave(response)

                error: () ->
                    saveBtn.button('reset')
                    self.errorAction()

        else
            self.saveAction()


    beforeSave: () ->
        undefined

    listMessages: (messages = {}) ->
        # https://www.pivotaltracker.com/story/show/89632216
        # If there are multiple messages, list them in bullets. If only one, don't.
        if Object.keys(messages).length > 1
            o = '<ul>'
            for k, v of messages
                o += "<li>#{v}</li>"
            o += '</ul>'
            return o
        else
            for k, v of messages
                return v


    afterSave: (data, timeout = 2000) ->
        self = this

        writer = self.dialog.find('.message_writer')

        if data? and data.status?.type is 'logout'
            window.location = '/home'
            return

        if @useMessageWriter
            o = data.status?.msg
            if data.status?.type isnt 'success'
                if data.data?.messages?
                    o += self.listMessages data.data?.messages
            if writer.length isnt 0 and $.contains(document, writer[0])
                writer.message_writer(data.status?.type, o)

        if data.status?.type is 'success'

            if @useMessageWriter and writer.length isnt 0 and $.contains(document, writer[0])
                writer.message_writer('hide', timeout)
            if not self.delayAfterSuccess
                self.successAction(data)
            if self.slideUpForm
                self.dialog.find('form').slideUp()
            setTimeout () =>
                if self.delayAfterSuccess
                    self.successAction(data)
                if self.destroyOnSave
                    self.destroy()
                if self.refreshNavHandler
                    App.current_page?.refreshSubHandlers?()
            , timeout
        else
            self.errorAction(data)

    ###
    afterLoadData: () ->
        # Resizeable /must/ happen after template render
        @dialog.resizable
            alsoResize: '.modal-body'
        @dialog.draggable
            handle: '.modal-header'


    refreshDialog: () ->

    loadData: (postopts) ->
        if @dataUrl?
            $.post @dataUrl,postopts,(data) =>
                out = data.data ? {}
                output = $(@template).render(out)
                @dialog.html(output)

                @afterLoadData()
    ###


    # Set the position of the dialog relative to the current viewport, using
    # the string format: 'vertPos horizPos', where
    # vertPos = {'top', 'middle', 'bottom'}
    # horizPos = {'left', 'middle', 'right'}
    #
    # Implementation notes:
    # The order of vertPos and horizPos can be switched (e.g., 'right top').
    # Single words are allowed, with the following provisions:
    # - 'middle' or 'center' will be handled as 'middle middle'
    # - 'top' or 'bottom' assumes horizPos should be 'middle'
    # - 'left' or 'right' assumes vertPos should be 'middle'
    # The dialog should never go off the bottom or right side of the screen,
    # unless 'top' or 'left' is specified, so the buttons are always visible.
    #
    # TODO #1: implement cooordinate-based x,y positioning
    # TODO #2: implement positioning relative to the parent handler div
    # TODO #3: make this a separate utility or jQuery plugin
    # -SK
    setPosition: (str = null) ->
        str = str ? @startPosition

        # make sure we have a string to work with
        if not str? or typeof str isnt 'string' or not str.length
            return

        debugLog 'positioning dialog at ' + str

        # parse the string, splitting on whitespace and/or a comma
        words = str.split(/\s+|\s*,\s*/)

        vertWords = ['top', 'bottom']
        horizWords = ['left', 'right']
        middleWords = ['center', 'middle']

        if words.length is 1
            # handle single word positions
            if words[0] in vertWords
                vertPos = words[0]
                horizPos = 'middle'

            else if words[0] in horizWords
                vertPos = 'middle'
                horizPos = words[0]

            else if words[0] in middleWords
                vertPos = 'middle'
                horizPos = 'middle'

        else if words.length is 2

            # handle clear cases, like 'top', 'bottom', 'left', 'right'
            if words[0] in vertWords then vertPos = words[0]
            else if words[1] in vertWords then vertPos = words[1]

            if words[1] in horizWords then horizPos = words[1]
            else if words[0] in horizWords then horizPos = words[0]

            # handle 'center', 'middle', and ommited centerPos/vertPos
            if words[0] in middleWords
                if horizPos? then vertPos = 'middle'
                else if vertPos? then horizPos = 'middle'
                else vertPos = 'middle'

            if words[1] in middleWords
                if vertPos? then horizPos = 'middle'
                else if horizPos? then vertPos = 'middle'
                else vertPos = 'middle'

        if not horizPos? or not vertPos?
            debugLog 'Failed to parse position'
            return

        debugLog 'Parsed as ' + vertPos + ' ' + horizPos

        # set the margins to 0 so that positioning makes sense
        pos = # {}
            margin: '0px'
            top: 'auto'
            bottom: 'auto'
            left: 'auto'
            right: 'auto'

        # set the x coordinate
        windowWidth = $(window).width()
        dialogWidth = $(@dialog).width()
        widthDiff = windowWidth - dialogWidth
        debugLog "window width: #{windowWidth}, dlg width: #{dialogWidth}, middle: " + (windowWidth - dialogWidth) / 2
        switch horizPos
            when 'left' then pos.left = 0
            when 'middle' then pos.left = widthDiff / 2
            when 'right' then pos.left = widthDiff
            else return # something went terribly wrong...

        if widthDiff < 0 then pos.left = widthDiff
        pos.left += 'px'

        # set the y coordinate
        windowHeight = $(window).height()
        dialogHeight = $(@dialog).height()
        heightDiff = windowHeight - dialogHeight
        debugLog 'window height: ' + windowHeight +
            ', dialog height: ' +
            dialogHeight +
            ', middle: ' +
            (windowHeight - dialogHeight) / 2
        switch vertPos
            when 'top' then pos.top = 0
            when 'middle' then pos.top = heightDiff / 2
            when 'bottom' then pos.top = heightDiff
            else return # something went terribly wrong...

        if heightDiff < 0 then pos.top = heightDiff
        pos.top += 'px'

        @dialog.css pos

        debugLog "#{@dialog.css('top')}/#{@dialog.css('bottom')}, #{@dialog.css('left')}/#{@dialog.css('right')}"
